module.exports = __webpack_public_path__ + "static/Redux-Integration-06c07ff4ebef28f0f5cdce508bedb8db.png";